const config = {
  pageSize: 20,
  middlePageSize: 15,
  smallPageSize: 10,
  miniPageSize: 6,
  pageButtons: 10,
  counselLength: 100,
  mainBannerWidth: 1920,
  mainBannerHeight: 978,
  mobileMainBannerWidth: 750,
  mobileMainBannerHeight: 1308,
  minimumPageSize: 5,

  tossClientKey: 'test_ck_ZORzdMaqN3wdjQjnYEPV5AkYXQGw',
  tossCallbackUrl: 'https://sum.canb-english.com',
  posReceiptUrl:
    'https://pgweb.tosspayments.com:9091/MpFlowCtrl?eventDiv1=search&eventDiv2=getReceipt&SYSTEM=NEW&authResultParam=Y&TRANSACTIONID=',

  levelUpDefault: {
    standardScore: '70',
    labels: [
      'MT1: O, MT2: O, TT: O, CANB ON: O',
      'MT1: X, MT2: O, TT: O, CANB ON: O',
      'MT1: O, MT2: X, TT: O, CANB ON: O',
      'MT1: X, MT2: X, TT: O, CANB ON: O',
      'MT1: O, MT2: O, TT: O, CANB ON: X',
      'MT1: X, MT2: O, TT: O, CANB ON: X',
      'MT1: O, MT2: X, TT: O, CANB ON: X',
      'MT1: X, MT2: X, TT: O, CANB ON: X',
    ],
    weights: [
      {
        scoreWeightCode: '01',
        mt1ScoreWeight: '20',
        mt2ScoreWeight: '20',
        ttScoreWeight: '50',
        icoachingScoreWeight: '1.5',
        elearningScoreWeight: '8.5',
      },
      {
        scoreWeightCode: '02',
        mt1ScoreWeight: '0',
        mt2ScoreWeight: '40',
        ttScoreWeight: '50',
        icoachingScoreWeight: '1.5',
        elearningScoreWeight: '8.5',
      },
      {
        scoreWeightCode: '03',
        mt1ScoreWeight: '40',
        mt2ScoreWeight: '0',
        ttScoreWeight: '50',
        icoachingScoreWeight: '1.5',
        elearningScoreWeight: '8.5',
      },
      {
        scoreWeightCode: '04',
        mt1ScoreWeight: '0',
        mt2ScoreWeight: '0',
        ttScoreWeight: '90',
        icoachingScoreWeight: '1.5',
        elearningScoreWeight: '8.5',
      },
      {
        scoreWeightCode: '05',
        mt1ScoreWeight: '20',
        mt2ScoreWeight: '20',
        ttScoreWeight: '60',
        icoachingScoreWeight: '0',
        elearningScoreWeight: '0',
      },
      {
        scoreWeightCode: '06',
        mt1ScoreWeight: '0',
        mt2ScoreWeight: '40',
        ttScoreWeight: '60',
        icoachingScoreWeight: '0',
        elearningScoreWeight: '0',
      },
      {
        scoreWeightCode: '07',
        mt1ScoreWeight: '40',
        mt2ScoreWeight: '0',
        ttScoreWeight: '60',
        icoachingScoreWeight: '0',
        elearningScoreWeight: '0',
      },
      {
        scoreWeightCode: '08',
        mt1ScoreWeight: '0',
        mt2ScoreWeight: '0',
        ttScoreWeight: '100',
        icoachingScoreWeight: '0',
        elearningScoreWeight: '0',
      },
    ],
  },

  canbonAndroidUrl:
    'https://play.google.com/store/apps/details?id=com.koreapolyschool.canb',
  canbonPcUrl:
    'https://file.koreapolyschool.com/lms/viewer/version/READI Installer_1.0.0.exe',
  alexAndroidUrl: 'https://play.google.com/store/apps/details?id=com.kps.alex',
  alexIosUrl: 'itms-apps://itunes.apple.com/us/app/canb-alex/id1635698862?mt=8',
  alexPcUrl:
    'https://file.koreapolyschool.com/lms/canb_alex/launcher/CANB_Alex_setup_2.1.1.exe',
  edubaseUrl: 'https://file.koreapolyschool.com/Contents/Edubase',
};

export default config;
